export const modalMessageText = 'Please confirm you want to Delete this clinic?';
export const okButtonText = 'Yes';
export const cancelButtonText = 'Cancel';
export const deleteEvent = 'Delete';
export const okButtonTextCopy='Ok'